import RoleTable from "./pages/RoleTable";

const Role: React.FC = () => {
  return (
    <div className="">
     <RoleTable/>
    </div>
  );
};

export default Role;
